<template>
    <div v-if="!assignment">...loading</div>
    <div v-else class="flex flex-col h-full">
        <div class="flex gap-2 items-center font-bold mb-2">
            <UButton
                v-if="isListView"
                icon="i-ph-x"
                variant="ghost"
                color="neutral"
                @click="$emit('close')"
            />
            <h2> Detaljer </h2>
        </div>

        <assignment-details-content :assignment="assignment" @updated="refreshAssignment" />
    </div>
</template>

<script setup lang="ts">

import {computed, ref} from 'vue'
import {Assignment} from '@/assignments/Assignment.type'
import {findByAssignmentUuid} from '@/assignments/assignment.service'
import {GridApi} from 'ag-grid-community'
import {computedAsync} from '@vueuse/core'
import AssignmentDetailsContent from '@/assignments/AssignmentDetailsContent.vue'

defineEmits(['close'])

const props = defineProps({
    assignmentUuid: {
        type: String,
        required: true
    },
    gridApi: {
        type: Object as () => GridApi<Assignment>
    },
    isListView: {
        type: Boolean,
        default: true
    }
})

const overrideAssignment = ref<Assignment | null>(null)

const gridAssignment = computedAsync(async () => {
    if (props.gridApi) {
        const node = props.gridApi.getRowNode(props.assignmentUuid)
        if (node && node.data) {
            return node.data
        }
    }
    // fallback in case not found in the loaded data
    const fetched = await findByAssignmentUuid(props.assignmentUuid)
    if (fetched) {
        console.warn('could not find assignment node in GridApi', props.assignmentUuid)
        return fetched
    }
})

const assignment = computed(() => overrideAssignment.value ?? gridAssignment.value)

const refreshAssignment = async () => {
    const fetched = await findByAssignmentUuid(props.assignmentUuid)
    if (fetched) {
        overrideAssignment.value = fetched
    }
}

</script>

<style scoped>

</style>
